import React from "react";
import { BarChart } from "@mui/x-charts/BarChart";

export default function BarChartGBALarge(props) {
  const { forecastDate, updateDate, cityData, gbaData } = props;

  if (!Array.isArray(cityData) || !Array.isArray(gbaData)) return null;

  // 提取城市名称和对应预测值
  const cityNames = cityData.map((item) => item.city).concat("珠三角九市");
  const gdpValues = cityData.map((item) => item.value).concat(gbaData[0]);

  return (
    <div>
      <h3>{forecastDate} 预测值</h3>
      <BarChart
        height={450}
        xAxis={[
          {
            scaleType: "band",
            data: cityNames,
            label: "城市",
            tickLabelStyle: { fontSize: 12 },
          },
        ]}
        yAxis={[{}]}
        series={[
          {
            label: " GDP增速预测值",
            data: gdpValues,
            color: "#8b0012",
          },
        ]}
        margin={{ top: 30, right: 30, bottom: 60, left: 30 }}
      />
      <p className="updateDate" style={{ marginTop: "10px" }}>
        注：图中为累计同比数据，珠三角九市的GDP预测方法与广深相关经济指标存在差异，详见“常见问题”与“相关研究”说明。
      </p>
      <p className="updateDate">更新时间：{updateDate}</p>
    </div>
  );
}
